import { useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';

import axiosInstance, { cancelTokenSource } from '../api/axios';
import { API_ROUTES } from '../enums/API_ROUTES';
import { NOTIFICATION, TRANSCODING_STATUS } from '../enums/ENUMS';
import { useAppDispatch } from '../store/hooks';
import { updateTranscodingStatus, updateUploadProgress } from '../store/sharedStore/sharedStoreSlice';

type TUploadForm = {
  file: File | Blob;
  title: string;
  folderId: string;
};

// deprecated
export const useUpload = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [progress, setProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const notification = useSnackbar();
  const dispatch = useAppDispatch();

  const refreshHook = () => {
    setIsSuccess(false);
    setErrorMessage('');
    setProgress(0);
    dispatch(updateUploadProgress(0));
    dispatch(updateTranscodingStatus(TRANSCODING_STATUS.DEFAULT));
  };

  const uploadForm = async ({ file, title, folderId }: TUploadForm) => {
    const formData = new FormData();
    formData.append('file', file);
    await axiosInstance.post(`${API_ROUTES.UPLOAD_CONTENT}?title=${title}&folderId=${folderId}`, formData, {
      onUploadProgress: (progressEvent) => {
        const progressBar = (progressEvent.loaded / progressEvent.total!) * 100;

        dispatch(updateUploadProgress(progressBar));
        setProgress(progressBar);
      },
    })
      .then((data) => {
        setIsSuccess(true);
        return data;
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          notification.showMessage(err.response.data.message);
          setErrorMessage(err.response.data.message);
        } else {
          notification.showMessage(NOTIFICATION.FILE_NOT_UPLOADED);
        }
        setIsSuccess(false);
        return err;
      });
  };

  const cancelUploading = () => {
    cancelTokenSource.cancel();
    window.location.reload();
  };

  return { uploadForm, isSuccess, progress, refreshHook, errorMessage, cancelUploading, setErrorMessage };
};
